<ng-container *ngIf="showAccessStatus">
  <span *ngIf="accessStatus$ | async as accessStatus">
    <span [class]="'badge badge-secondary access-status-list-element-badge ' + accessStatusClass">{{ accessStatus | translate }}</span>
  </span>
</ng-container>
